import { render, staticRenderFns } from "./SectorSubmitBar.vue?vue&type=template&id=1837030a&"
import script from "./SectorSubmitBar.vue?vue&type=script&lang=js&"
export * from "./SectorSubmitBar.vue?vue&type=script&lang=js&"
import style0 from "./SectorSubmitBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging.appraisal.owiwi.co.uk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1837030a', component.options)
    } else {
      api.reload('1837030a', component.options)
    }
    module.hot.accept("./SectorSubmitBar.vue?vue&type=template&id=1837030a&", function () {
      api.rerender('1837030a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SectorSubmitBar/SectorSubmitBar.vue"
export default component.exports